import React, { createContext, useState } from "react";
import { getToken, saveToken, clearToken } from "./auth";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setTokenState] = useState(getToken());

  const setToken = (t) => {
    if (t) saveToken(t);
    else clearToken();
    setTokenState(t);
  };

  return (
    <AuthContext.Provider value={{ token, setToken }}>
      {children}
    </AuthContext.Provider>
  );
};
